import { BlueberryDefaultsProvider } from '../blueberry/BlueberryDefaultsProvider'
import { AuthProvider } from '../authContext/AuthContext'
import { PageLayout } from './PageLayout'
import { OrgConfigProvider } from '../orgConfigContext/OrgConfigContext'

const AppContent = () => {
  return (
    <AuthProvider>
      <OrgConfigProvider>
        <BlueberryDefaultsProvider>
          <PageLayout />
        </BlueberryDefaultsProvider>
      </OrgConfigProvider>
    </AuthProvider>
  )
}

export { AppContent }
